/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { HashLink } from 'react-router-hash-link';

import {
  BLACK,
  WHITE,
  GRAY_BG,
  GRAY_MID,
  GRAY_DARK,
  GREEN_LIGHT,
  PURPLE_FEEK,
  PURPLE_LIGHT,
  WHITE_ALMOST,
  GRAY_LIGHTER,
  PURPLE_MEDIUM,
} from 'styles/colors';
import Icon from 'components/Icon';
import Text from 'components/Text';
import {
  getFluidSize,
  getFontSizeAndLineHeigh,
} from 'utils/cssStringManipulation';
import { titlesFeekApp } from 'constants';
import { Slogan } from 'components/Slogan';
import { MEDIA_QUERIES } from 'styles/constants';
import Plans from 'screens/manager/Landing/Plans';
import FeekPhone from 'assets/images/FeekPhone.png';
import WhyFeek from 'screens/manager/Landing/WhyFeek';
import ComunidadFeek from 'assets/images/ComunidadFeek.png';
import SignInForm from 'screens/manager/Landing/SignInForm';
import FooterLandingPurple from 'components/FooterLandingPurple';
import DataToRegister from 'screens/manager/Landing/DataToRegister';
import { FeekFeatures } from 'screens/manager/Landing/FeekFeatures';
import FeekspotsCities from 'screens/manager/Landing/FeekspotsCities';
import { ReactComponent as FeekLogo } from 'assets/icons/FeekLogo.svg';
import FeekspotsCarrousel from 'screens/manager/Landing/FeekspotsCarrousel';
import { ReactComponent as CheckCircle } from 'assets/icons/CheckCircle.svg';
import LandingBussinessHeroBg from 'assets/images/LandingBussinessHeroBg.png';

const styles = css`
  ul,
  ol {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  min-height: 100vh;
  scroll-behavior: smooth;

  .draggableEmoji {
    transition: font-size 0.1s ease-in-out,
      text-shadow 0.1s ease-in-out;
    position: absolute;
    font-size: 60px;
    cursor: grab;

    :hover,
    :active {
      font-size: 120%;
      text-shadow: 10px 10px 4px ${GRAY_LIGHTER};
    }
  }

  .tag {
    display: inline flex;
    align-items: center;
    border-radius: 30px;
  }

  .header {
    padding: 20px 20px 20px 35px;
    position: absolute;
    top: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    backdrop-filter: blur(5px);
    ${'' /* z-index avoid phone input overlapping */}
    z-index: 1;

    &,
    .brandWrapper,
    .navigation {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: ${getFluidSize(5, 40)};
    }

    .navigation {
      gap: ${getFluidSize(0, 48)};

      .navButton {
        display: flex;
        align-items: center;
        text-decoration: none;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: ${WHITE};
      }

      .goToSignInButton {
        width: auto;
        border-radius: 24px;
        padding: 15px 20px;
        background-color: ${GREEN_LIGHT};
        color: ${PURPLE_FEEK};
        font-size: 16px;
        font-weight: 600;
        line-height: 100%;
      }
    }
  }

  .hero {
    padding: 200px 70px 130px;
    background-image: url(${LandingBussinessHeroBg});
    display: flex;
    justify-content: space-between;
    background-size: cover;

    .hero-title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 40px;
      .hero-text-content {
        > :nth-of-type(1) {
          margin-block-end: 30px;
        }
      }
    }

    .hero-phone-wrapper {
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: stretch;
      gap: 48px;
    }

    .hero-bubble {
      background: rgba(243, 230, 254, 0.2);
      border-radius: 57.547px;
      border: 1px solid #efeeff;
      padding: 24px 85px;
      margin-top: auto;
      width: 100%;
      box-sizing: border-box;
      position: relative;

      .hero-bubble-eyes {
        position: absolute;
        top: -33px;
        left: 24px;
        font-size: 65.743px;
        line-height: 1;
        width: 65.743px;
        height: 65.743px;
        display: block;
      }

      .hero-bubble-text {
        color: #efeeff;
        leading-trim: both;
        text-edge: cap;
        font-family: Roobert, sans-serif;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        line-height: 145%;
        margin: 0;
      }
    }
  }
  .color-purple-light {
    color: ${PURPLE_LIGHT};
  }

  .knowOurFeekers {
    display: flex;
    align-items: center;
    gap: 30px;
    border-radius: 30px;
    border: 1px solid ${GRAY_MID};
    padding: 30px;

    .circularHashLink {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 47px;
      aspect-ratio: 1;
      background-color: ${WHITE_ALMOST};
    }
  }

  .article {
    position: relative;
    margin-inline: 70px;
  }

  .comunidad {
    display: flex;
    align-items: center;
    background-color: ${PURPLE_LIGHT};
    justify-content: space-between;
  }

  .comunidad-title {
    margin: 0;
    ${getFontSizeAndLineHeigh(48)}
    padding: 1em 2em;
    max-width: 950px;

    ${MEDIA_QUERIES.mobile} {
      padding: 1em;
    }
  }

  .users {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10vw;
    margin-block-start: 196px;
    padding-inline: calc(125px + 5vw);

    .imageFriendsEating {
      width: 450px;
      height: 560px;
      border-radius: 30px;
      object-fit: cover;
      object-position: center;
    }

    .checkList {
      margin-block-start: 60px;
    }
  }

  .clients {
    margin-block-start: 200px;
  }

  ${MEDIA_QUERIES.smallScreen} {
    .hero {
      .hero-title {
        .hero-main-title {
          margin: 0;
          font-size: 42px;
          line-height: 50px;
        }
        .hero-text-content {
          > :nth-of-type(2) {
            ${getFontSizeAndLineHeigh(18)}
          }
        }
      }
    }
  }

  ${MEDIA_QUERIES.tablet} {
    .comunidad {
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: ${PURPLE_LIGHT};
      justify-content: space-between;

      img {
        width: 100%;
      }
    }

    .comunidad-title {
      ${getFontSizeAndLineHeigh(42)}
      padding: 80px;
      text-align: center;
      max-width: 900px;
    }
    .hero {
      img {
        display: none;
      }
      .hero-bubble {
        display: none;
      }
      .hero-title {
        .hero-main-title {
          font-size: 30px;
          line-height: 36px;
        }
        .hero-text-content {
          > :nth-of-type(2) {
            ${getFontSizeAndLineHeigh(15)}
          }
        }
      }
    }
  }

  ${MEDIA_QUERIES.mobile} {
    width: 100vw;
    overflow: hidden;

    .showOnMobileOnly {
      display: revert !important;
    }

    .hideOnMobile {
      display: none !important;
    }

    .landing-title {
      ${getFontSizeAndLineHeigh(32)}
      text-align: center;
      place-self: center;
    }

    .roundedCardBig {
      width: 80vw;
      flex: 1 0 80vw;
      border-radius: 20px;
      scroll-snap-align: center;
      max-width: initial;

      :first-of-type {
        margin-inline-start: 20px;
      }

      :last-of-type {
        margin-inline-end: 20px;
      }
    }

    .header {
      top: 0;
      width: 100vw;
      padding: 20px;
      margin: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;

      .navigation {
        .goToSignInButton {
          font-size: 17px;
        }
      }
    }

    .hero {
      padding: 150px 20px 608px;
      border-radius: 0px;
      background-color: ${GREEN_LIGHT};

      .hero-title {
        width: 100%;
        margin-block-end: 0;

        .hero-text-content {
          > :nth-of-type(1) {
            margin-block-end: 40px;
            ${getFontSizeAndLineHeigh(32)}
            font-weight: 600;
          }
          > :nth-of-type(2) {
            ${getFontSizeAndLineHeigh(16)}
          }
        }
        .hero-main-title {
          font-size: 24px;
          line-height: 29px;
        }
      }
      img {
        display: none;
      }
    }

    .article {
      display: flex;
      margin: 100px 20px;
      padding: 0;
      flex-direction: column;
      gap: 40px;
      align-items: start;
    }

    .users {
      .imageFriendsEating {
        width: 100%;
        height: auto;
        aspect-ratio: 1;
      }
    }

    .clients {
      .landing-title .draggableEmoji {
        &:nth-of-type(2) {
          top: 140px;
          left: 2%;
        }
        &:nth-of-type(3) {
          top: 128px;
          left: 80%;
        }
        &:last-of-type {
          top: 35px;
          left: 50%;
          rotate: 30deg;
        }
      }

      .clientsList {
        display: contents;
      }
    }
  }
`;

export const landingIds = {
  signInForm: 'signInForm',
  users: 'users',
  clients: 'clients',
  benefits: 'benefits',
  cities: 'cities',
  requirements: 'requirements',
};

function CheckListElement({ text }) {
  return (
    <li className="checkListElement">
      <Icon
        className="bullet"
        icon={CheckCircle}
        color={BLACK}
        size={22}
      />
      <Text className="checkListText" fontSize={16} color={BLACK}>
        {text}
      </Text>
    </li>
  );
}

function LandingManager() {
  document.title = titlesFeekApp.LandingManager;

  return (
    <div css={styles}>
      <header className="header">
        <div className="brandWrapper">
          <Icon size={50} icon={FeekLogo} color={WHITE} />
          <Slogan
            className="hideOnMobile"
            color={WHITE}
            fontSize={20}
            type="inline"
          />
        </div>

        <nav className="navigation">
          <HashLink
            className="navButton hideOnMobile"
            elementId={landingIds.users}
            smooth
          >
            Usuarios
          </HashLink>

          <HashLink
            className="navButton hideOnMobile"
            elementId={landingIds.clients}
            smooth
          >
            Nuestros clientes
          </HashLink>

          <HashLink
            className="navButton hideOnMobile"
            elementId={landingIds.benefits}
            smooth
          >
            Beneficios
          </HashLink>

          <HashLink
            className="navButton hideOnMobile"
            elementId={landingIds.cities}
            smooth
          >
            Ciudades
          </HashLink>

          <HashLink
            className="navButton hideOnMobile"
            elementId={landingIds.requirements}
            smooth
          >
            Requerimientos
          </HashLink>

          <a
            className="goToSignInButton navButton"
            href="https://www.feekmanager.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Registra tu negocio
          </a>
        </nav>
      </header>

      <section className="hero">
        <div className="hero-title">
          <div className="hero-text-content">
            <div>
              <Text
                type="h1"
                className="hero-main-title"
                color={PURPLE_MEDIUM}
                fontSize={56}
                fontWeight={500}
              >
                La mejor<br></br> herramienta para{' '}
                <b className="color-purple-light">
                  impulsar tu negocio.
                </b>
              </Text>
            </div>

            <Text color={PURPLE_MEDIUM} fontSize={22}>
              <u
                className="color-purple-light"
                id={landingIds.signInForm}
              >
                Regístrate con nosotros
              </u>{' '}
              y posiciona tu negocio en
              <br /> nuevos segmentos... los clientes no dejarán de
              llegar.
            </Text>
          </div>
          <SignInForm />
        </div>
        <div className="hero-phone-wrapper">
          <img
            src={FeekPhone}
            alt="App Feek en smartphone - Plataforma de creadores de contenido para negocios"
          />
          <div className="hero-bubble hideOnMobile">
            <span className="hero-bubble-eyes">👀</span>
            <p className="hero-bubble-text">
              <b>¿Qué esperas?</b>, ¡comienza a explotar los
              beneficios de formar parte de <b>Feek!</b>
            </p>
          </div>
        </div>
      </section>
      <article className="comunidad">
        <Text type="h2" className="comunidad-title" color={GRAY_DARK}>
          <b>Con Feek</b> crea una <u>comunidad</u> de clientes de
          manera <b>orgánica y genuina.</b>
        </Text>
        <img
          src={ComunidadFeek}
          alt="Comunidad de creadores de contenido Feek generando publicidad orgánica"
        />
      </article>

      <WhyFeek />

      <article id={landingIds.users} className="article users">
        {/* <img src={FriendsEatingPNG} alt="¿Quién usa Feek?" /> */}
      </article>

      <FeekFeatures />

      <Plans />

      <article
        id={landingIds.clients}
        style={{ backgroundColor: GRAY_BG }}
      >
        <FeekspotsCarrousel />
      </article>

      <FeekspotsCities />
      <DataToRegister />
      <FooterLandingPurple />
    </div>
  );
}

CheckListElement.propTypes = {
  text: PropTypes.string.isRequired,
};

export default LandingManager;
